
// @todo do usunięcia po usunięciu starych modelu danych (np. adresu) z restServicesBase z ihbase
angular.module('lsnBase.deprecated.models')
  .factory('LsnIHestiaMetaDataModelV1', ['LsnMetaDataModelV1',
    function(LsnMetaDataModelV1) {
      return LsnMetaDataModelV1;
    }
  ]);